import { render, staticRenderFns } from "./Report.vue?vue&type=template&id=a80b164a&scoped=true&"
import script from "./Report.vue?vue&type=script&lang=js&"
export * from "./Report.vue?vue&type=script&lang=js&"
import style0 from "./Report.vue?vue&type=style&index=0&id=a80b164a&media=screen&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a80b164a",
  null
  
)

export default component.exports